webpackJsonp([144342403179678],{

/***/ 414:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":1},"site":{"siteMetadata":{"title":"Chetan Arya's technology blog","author":"Chetan Arya","facebook":{"appId":""}}},"markdownRemark":{"id":"/opt/build/repo/content/posts/hello-world/index.md absPath of file >>> MarkdownRemark","fields":{"slug":"/hello-world/"},"html":"<p>Hello world.\n<img src=\"./photo-1465070845512-2b2dbdc6df66.jpg\" alt=\"unsplash.com\"></p>","frontmatter":{"title":"Hello World","date":"July 03, 2018","tags":["tag-1","tag-2","sample"],"cover":{"relativePath":"hello-world/salty_egg.jpg"}}}},"pathContext":{"slug":"/hello-world/","previous":null,"next":{"fields":{"slug":"/"},"frontmatter":{"title":"","tags":null}}}}

/***/ })

});


// WEBPACK FOOTER //
// path---hello-world-5612f370cf30c35f83a6.js